module.exports = __webpack_public_path__ + "static/media/image-grid-2.45c72367.svg";